import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useStatus = () => {
  const [values, setValues] = useState(null);
  const { t } = useTranslation();

  if (!values) {
    setValues([
      { label: t('FILTERS.active'), value: true },
      { label: t('FILTERS.notActive'), value: false },
    ]);
  }

  return values;
};

export { useStatus };
